import { gql } from "@apollo/client";

export default gql`
  mutation removeEmployer($id: ID!) {
    removeEmployer(id: $id)
  }
`;
